(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeItemDeleteController',HandbookMergeItemDeleteController);

    HandbookMergeItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookMergeItem'];

    function HandbookMergeItemDeleteController($uibModalInstance, entity, HandbookMergeItem) {
        var vm = this;

        vm.handbookMergeItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookMergeItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
